import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl, useIntl } from 'react-intl';
import enumCache from '@/shared/services/EnumCacheService';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import RelationTypeIcon from '@/shared/components/RelationTypeIcon';
import intlShape from '@/shared/utils/intlShape';

class RelationTypeButtonGroup extends Component {
  state = {
    relationTypes: [],
  };

  componentDidMount() {
    const { intl } = this.props;
    enumCache.get('relationtype').then(relationTypes => {
      this.setState({
        relationTypes: relationTypes
          .map(item => ({
            id: item.key,
            label: intl.formatMessage(listItemMsg('relationtype', item.key, item.value)),
          }))
          .sort(dynamicSort('label')),
      });
    });
  }

  toggleRelationType = relType => {
    const { selectedTypes = [], onChange } = this.props;
    const idx = selectedTypes.indexOf(relType);
    if (idx >= 0) {
      onChange(selectedTypes.filter((_, i) => i !== idx));
    } else {
      onChange([...selectedTypes, relType]);
    }
  };

  render() {
    const { relationTypes } = this.state;
    const { selectedTypes = [] } = this.props;

    return (
      <div role="group" aria-label="relationType" className="btn-group btn-group-justified">
        {relationTypes &&
          relationTypes.map(t => (
            <button
              key={`RelTypeFilter${t.id}`}
              onClick={() => {
                document.activeElement.blur();
                this.toggleRelationType(t.id);
              }}
              type="button"
              title={t.label}
              className={classnames('btn btn-default no-overflow', {
                active: selectedTypes.includes(t.id),
              })}
            >
              <RelationTypeIcon type={t.id} />
              {t.label}
            </button>
          ))}
      </div>
    );
  }
}

RelationTypeButtonGroup.propTypes = {
  intl: intlShape.isRequired,
  selectedTypes: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
};

RelationTypeButtonGroup.defaultProps = {
  selectedTypes: [],
};

export default injectIntl(RelationTypeButtonGroup);
